import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps } from '@ngrx/store';
import {
  DepositBonusAvailability,
  DepositBonusList,
  DepositBonusAmount
} from '../models/deposit-bonus';

export const DepositBonusActions = createActionGroup({
  source: 'Deposit Bonus',
  events: {
    getDepositBonusAvailability: (accountId: number, lang: string) => ({ accountId, lang }),
    getDepositBonusAvailabilitySuccess: (depositBonusAvailability: DepositBonusAvailability) => ({ depositBonusAvailability }),
    getDepositBonusAvailabilityFailure: (err: HttpErrorResponse) => ({ err }),

    getDepositBonusList: (accountId: number) => ({ accountId }),
    getDepositBonusListSuccess: (accountId: number, depositBonusList: DepositBonusList) => ({ accountId, depositBonusList }),
    getDepositBonusListFailure: (err: HttpErrorResponse) => ({ err }),

    getDepositBonusAmount: (accountId: number, depositAmount: number, wasReceived: boolean) =>
      ({ accountId, depositAmount, wasReceived }),
    getDepositBonusAmountSuccess: (depositBonusAmount: DepositBonusAmount) => ({ depositBonusAmount }),
    getDepositBonusAmountFailure: (err: HttpErrorResponse) => ({ err }),

    clearDepositBonusAmount: emptyProps(),
  },
});

export const {
  getDepositBonusAvailability,
  getDepositBonusAvailabilitySuccess,
  getDepositBonusAvailabilityFailure,

  getDepositBonusList,
  getDepositBonusListSuccess,
  getDepositBonusListFailure,

  getDepositBonusAmount,
  getDepositBonusAmountSuccess,
  getDepositBonusAmountFailure,

  clearDepositBonusAmount,
} = DepositBonusActions;
